module.exports = __webpack_public_path__ + "img/lg_ring_y_o_1_0.31d9d5ec.png";